import * as React from "react";
const SvgBigGreenTickMark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="m12.096 18 3.931 3.93 7.876-7.86m-5.904 17.82c7.64 0 13.89-6.25 13.89-13.89S25.64 4.11 18 4.11 4.11 10.36 4.11 18 10.36 31.89 18 31.89"
    />
  </svg>
);
export default SvgBigGreenTickMark;
